import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { atualizarUsuario, getUsuario } from "../../api/apiService";
import { getUBSs } from "../../api/apiService";
import styles from "../../styles/AtualizarCadastro.module.css"; // Reaproveitando o CSS
import Navbar from "../../components/Navbar";
import {
  TextField,
  Button,
  CircularProgress,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";

const estadosBrasil = [
  { sigla: "AC", nome: "Acre" },
  { sigla: "AL", nome: "Alagoas" },
  { sigla: "AP", nome: "Amapá" },
  { sigla: "AM", nome: "Amazonas" },
  { sigla: "BA", nome: "Bahia" },
  { sigla: "CE", nome: "Ceará" },
  { sigla: "DF", nome: "Distrito Federal" },
  { sigla: "ES", nome: "Espírito Santo" },
  { sigla: "GO", nome: "Goiás" },
  { sigla: "MA", nome: "Maranhão" },
  { sigla: "MT", nome: "Mato Grosso" },
  { sigla: "MS", nome: "Mato Grosso do Sul" },
  { sigla: "MG", nome: "Minas Gerais" },
  { sigla: "PA", nome: "Pará" },
  { sigla: "PB", nome: "Paraíba" },
  { sigla: "PR", nome: "Paraná" },
  { sigla: "PE", nome: "Pernambuco" },
  { sigla: "PI", nome: "Piauí" },
  { sigla: "RJ", nome: "Rio de Janeiro" },
  { sigla: "RN", nome: "Rio Grande do Norte" },
  { sigla: "RS", nome: "Rio Grande do Sul" },
  { sigla: "RO", nome: "Rondônia" },
  { sigla: "RR", nome: "Roraima" },
  { sigla: "SC", nome: "Santa Catarina" },
  { sigla: "SP", nome: "São Paulo" },
  { sigla: "SE", nome: "Sergipe" },
  { sigla: "TO", nome: "Tocantins" },
];

const AtualizarCadastro = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    nomeCompleto: "",
    email: "",
    cpf: "",
    dataNascimento: "",
    telefone: "",
    cep: "",
    endereco: "",
    numero: "",
    complemento: "",
    bairro: "",
    cidade: "",
    estado: "",
    sus: "",
    ubsId: "",
  });

  const [ubsList, setUbsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [isSusEditable, setIsSusEditable] = useState(true); // Começa como editável

  const formatCpf = (cpf) =>
    cpf
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d)/, "$1.$2")
      .replace(/(\d{3})(\d{1,2})$/, "$1-$2");
  const convertDateFormat = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}/${month}/${year}`;
  };

  const formatTelefone = (telefone) => {
    const value = telefone.replace(/\D/g, "");
    if (value.length <= 2) return `(${value}`;
    if (value.length <= 6) return `(${value.slice(0, 2)}) ${value.slice(2)}`;
    if (value.length <= 10)
      return `(${value.slice(0, 2)}) ${value.slice(2, 6)}-${value.slice(6)}`;
    return `(${value.slice(0, 2)}) ${value.slice(2, 7)}-${value.slice(7, 11)}`;
  };

  const formatCep = (cep) =>
    cep.replace(/\D/g, "").replace(/(\d{5})(\d)/, "$1-$2");

  const formatSus = (sus) => {
    if (!sus) return ""; // Retorna vazio se o SUS não estiver presente
    const value = sus.replace(/\D/g, "");
    if (value.length <= 3) return value;
    if (value.length <= 7) return `${value.slice(0, 3)} ${value.slice(3)}`;
    if (value.length <= 11)
      return `${value.slice(0, 3)} ${value.slice(3, 7)} ${value.slice(7)}`;
    return `${value.slice(0, 3)} ${value.slice(3, 7)} ${value.slice(
      7,
      11
    )} ${value.slice(11, 15)}`;
  };

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await getUsuario();
        const susInicial = formatSus(data.paciente?.sus || "");
        setFormData({
          nomeCompleto: data.nome || "",
          email: data.email || "",
          cpf: formatCpf(data.paciente?.cpf || ""),
          dataNascimento: convertDateFormat(
            data.paciente?.dataNascimento || ""
          ),
          telefone: formatTelefone(data.paciente?.telefone || ""),
          cep: formatCep(data.paciente?.endereco?.cep || ""),
          endereco: data.paciente?.endereco?.endereco || "",
          numero: data.paciente?.endereco?.numero || "",
          complemento: data.paciente?.endereco?.complemento || "",
          bairro: data.paciente?.endereco?.bairro || "",
          cidade: data.paciente?.endereco?.cidade || "",
          estado: data.paciente?.endereco?.estado || "",
          sus: formatSus(data.paciente?.sus) || "", // Se estiver vazio, permite edição
          ubsId: data.paciente?.ubs?.id || "",
        });

        setIsSusEditable(susInicial === ""); // Bloqueia edição se já houver um número salvo
      } catch (error) {
        setError("Erro ao carregar dados do usuário.");
      }
    };

    const fetchUBSs = async () => {
      try {
        const ubsData = await getUBSs(true);
        setUbsList(ubsData);
      } catch (error) {
        setError("Erro ao carregar lista de UBSs.");
      }
    };

    fetchUserData();
    fetchUBSs();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const cleanedData = {
        ...formData,
        cpf: formData.cpf.replace(/\D/g, ""),
        dataNascimento: formData.dataNascimento.split("/").reverse().join("-"),
        telefone: formData.telefone.replace(/\D/g, ""),
        cep: formData.cep.replace(/\D/g, ""),
        sus: formData.sus ? formData.sus.replace(/\D/g, "") : undefined, // Tratar SUS opcionalmente
      };

      if (cleanedData.sus && cleanedData.sus.length !== 15) {
        setError("O Número do SUS deve conter exatamente 15 dígitos.");
        setIsLoading(false);
        return;
      }

      await atualizarUsuario(cleanedData);

      toast.success("Dados atualizados com sucesso!", {
        position: "bottom-center",
        autoClose: 2000,
      });

      setTimeout(() => navigate("/"), 2500);
    } catch (error) {
      console.error("Erro ao atualizar:", error);
      setError("Erro ao atualizar dados. Tente novamente.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSusChange = (e) => {
    const formattedSus = formatSus(e.target.value);
    setFormData((prevData) => ({ ...prevData, sus: formattedSus }));
  };

  return (
    <div className="main-content">
      <Navbar />
      <div className={styles.atualizarUsuarioContainer}>
        <div className={styles.formCard}>
          <h2>Atualizar Cadastro</h2>
          {error && <p className={styles.errorMessage}>{error}</p>}
          <form onSubmit={handleSubmit}>
            <fieldset className={styles.fieldset}>
              <legend>Dados Pessoais</legend>
              <div className={styles.inputGroup}>
                <TextField
                  fullWidth
                  label="Nome Completo"
                  name="nomeCompleto"
                  value={formData.nomeCompleto}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.inputGroup}>
                <TextField
                  fullWidth
                  label="Data de Nascimento"
                  name="dataNascimento"
                  value={formData.dataNascimento}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.inputGroup}>
                <TextField
                  fullWidth
                  label="Telefone"
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.inputGroup}>
                <TextField
                  fullWidth
                  type="email"
                  label="Email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className={styles.inputGroup}>
                <FormControl fullWidth>
                  <InputLabel id="ubs-label">
                    Unidade Básica de Saúde
                  </InputLabel>
                  <Select
                    labelId="ubs-label"
                    name="ubsId"
                    value={formData.ubsId}
                    onChange={handleChange}
                    required
                  >
                    {ubsList.map((ubs) => (
                      <MenuItem key={ubs.id} value={ubs.id}>
                        {ubs.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </div>

              <div className={styles.addressGroup}>
                <div className={styles.inputGroup}>
                  <TextField
                    fullWidth
                    label="CPF"
                    name="cpf"
                    value={formData.cpf}
                    readOnly
                    disabled
                  />
                </div>
                <div className={styles.inputGroup}>
                  <TextField
                    fullWidth
                    label="Número do SUS"
                    name="sus"
                    value={formData.sus}
                    onChange={handleSusChange}
                    disabled={!isSusEditable}
                  />
                </div>
              </div>
            </fieldset>

            <fieldset className={styles.fieldset}>
              <legend>Endereço</legend>
              <div className={styles.addressGroup}>
                <div className={`${styles.inputGroup} ${styles.small}`}>
                  <TextField
                    fullWidth
                    label="CEP"
                    name="cep"
                    value={formData.cep}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className={styles.inputGroup}>
                  <TextField
                    fullWidth
                    label="Endereço"
                    name="endereco"
                    value={formData.endereco}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className={`${styles.inputGroup} ${styles.small}`}>
                  <TextField
                    fullWidth
                    label="Número"
                    name="numero"
                    value={formData.numero}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className={styles.addressGroup}>
                <div className={styles.inputGroup}>
                  <TextField
                    fullWidth
                    label="Complemento"
                    name="complemento"
                    value={formData.complemento}
                    onChange={handleChange}
                  />
                </div>
                <div className={styles.inputGroup}>
                  <TextField
                    fullWidth
                    label="Bairro"
                    name="bairro"
                    value={formData.bairro}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>
              <div className={styles.addressGroup}>
                <div className={styles.inputGroup}>
                  <TextField
                    fullWidth
                    label="Cidade"
                    name="cidade"
                    value={formData.cidade}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className={styles.inputGroup}>
                  <TextField
                    fullWidth
                    select
                    label="Estado"
                    name="estado"
                    value={formData.estado}
                    onChange={handleChange}
                    required
                  >
                    {estadosBrasil.map((estado) => (
                      <MenuItem key={estado.sigla} value={estado.sigla}>
                        {estado.nome}
                      </MenuItem>
                    ))}
                  </TextField>
                </div>
              </div>
            </fieldset>

            <Button
              type="submit"
              variant="contained"
              color="primary"
              fullWidth
              disabled={isLoading}
            >
              {isLoading ? (
                <CircularProgress size={24} style={{ color: "white" }} />
              ) : (
                "Atualizar"
              )}
            </Button>
            <Button
              onClick={() => navigate("../")}
              variant="outlined"
              color="secondary"
              fullWidth
              style={{ marginTop: "10px" }}
            >
              Voltar
            </Button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AtualizarCadastro;
